import { PayItemsOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/header'
import { useIssueTrackerContext } from '../IssueTrackerContext'
import { Issue } from '../IssueTrackerContext/types'

export function usePayItems(): PayItemsOptions<Issue> {
  const { payItemGlobalId } = useIssueTrackerContext()
  return {
    hidden: !!payItemGlobalId,
    globalId: payItemGlobalId,
    onFilter: (globalId, { payItems }) =>
      payItems.some((payItem) => payItem.globalId === globalId),
  }
}
